import { render, staticRenderFns } from "./currency-dollar.vue?vue&type=template&id=7472a788&"
import script from "./currency-dollar.vue?vue&type=script&lang=js&"
export * from "./currency-dollar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports